import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';
import gsap from "gsap";

function bannerSlider() {

    //console.log("bannerSlider TEST");

    const heroSlider = new Swiper(".banner-slider", {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        effect: 'fade',
        allowTouchMove: false,
        speed: 700,
        fadeEffect: {
            crossFade: true
        },

        breakpoints: {
            0: {
                allowTouchMove: true,
            },
            568: {
                allowTouchMove: true,
            },
            1024: {
                allowTouchMove: false,
            }
        },
        on: {
            transitionStart: function () {
                //console.log("object");
                //console.log(elem);
                //  var bnSlider = document.querySelector(".banner-slider");
                //   var videos = bnSlider.querySelectorAll('video');

                //   Array.prototype.forEach.call(videos, function(video){
                //     video.pause();
                //   });
            },

            transitionEnd: function () {

                // var activeIndex = this.activeIndex;
                // var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
                //var activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
                //activeSlideVideo.play();

            },

        }
    });



    const nextBtns = document.querySelectorAll('.banner-slider .next-slide-click');

    nextBtns.forEach(nextBtn => {
        nextBtn.addEventListener('click', () => {
            heroSlider.slideNext();
        })
    });

    // heroSlider.on("slideChangeTransitionStart", function() {
    //     gsap.fromTo(".banner-slider  .swiper-slide.swiper-slide-active .banner-info > *", {
    //         y: 100,
    //         autoAlpha: 0
    //     }, {
    //         duration: 1,
    //         ease: "power4.out",
    //         y: 0,
    //         stagger: 0.2,
    //         autoAlpha: 1
    //     });
    //     //gsap.set(".banner-slider  .swiper-slide.swiper-slide-active .banner-content > img", {clipPath: "polygon(100% 0, 100% 0, 100% 100%, 100% 100%)"})
    //     gsap.fromTo(".banner-slider  .swiper-slide.swiper-slide-active .banner-content > img", {
    //         clipPath: "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)",
    //         scale: 1.2,
    //         autoAlpha: 0
    //     }, {
    //         clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
    //         duration: .6,
    //         autoAlpha: 1,
    //         scale: 1,
    //         //ease: "power2.out",
    //         clearProps: "all",
    //         delay: .4,
    //     });
    // });

}

export default bannerSlider;

//module.exports = bannerSlider;